<template>
  <v-application v-if="access.setting_pos_devices">
    <v-layout row class="ma-2">
      <v-flex md8>
        <v-crud-card
          name="pos"
          v-bind:headers="headers"
          v-bind:data="data"
          v-bind:save="save"
          v-bind:row="edit"
          SettingsDevice
          v-bind:remove="remove"
          v-bind:add_button_name="'add_pos'"
          v-bind:saveDisabled="!is_valid"
        >
          <template #top>
            <v-combobox
              v-model="store"
              v-bind:items="stores"
              item-text="name"
              hide-details
              label="Store"
            />
          </template>
          <v-form v-model="is_valid">
            <v-card-text>
              <v-text-field
                v-model="device.name"
                :label="$t('name')"
                :rules="[fieldRules.required]"
              />
              <v-autocomplete
                v-model="device.service"
                v-bind:items="shifted_stores"
                :rules="[fieldRules.require]"
                item-value="_id"
                item-text="name"
                :label="$t('store')"
              />
            </v-card-text>
          </v-form>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
export default {
  name: "SettingsDevices",
  mixins: [Services],
  data: () => ({
    device_edit_index: -1,
    headers: [
      { text: "Name", value: "name", align: "left" },
      { text: "Status", value: "status" },
    ],
    is_valid: false,
    data: [],
    device: {
      name: null,
      service: null,
    },
    page: 1,
    totalPages: null,
    snackbar: false,
  }),
  mounted() {
    this.headers = [
      { text: this.$t("name"), value: "name", align: "left", available: true },
      { text: this.$t("status"), value: "status", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.update();
  },
  watch: {
    store() {
      this.$store.commit("setItemsService", this.store);
      this.update();
    },
  },
  methods: {
    async remove(items) {
      const indeces = [];
      for (const index in items) {
        indeces.push(items[index]._id);
      }
      const dalete = await this.$communicator("remove_devices", {
        params: {
          indexes: indeces,
        },
      });
      if (dalete.data.statusCode == 200) {
        this.$toast.success(`${dalete.data.message}`, { timeout: 2000 });
      }
      this.update();
    },
    edit(item) {
      if (item == null) {
        this.device_edit_index = -1;
        this.device = {
          name: null,
          service: null,
        };
      } else {
        this.device_edit_index = item._id;
        this.device = {
          name: item.name,
          service: item.service,
        };
      }
    },
    async update() {
      const devices = this.$communicator.then(
        this,
        await this.$communicator("devices", {
          params: {
            service: this.store ? this.store._id : "",
          },
        })
      );
      if (devices) {
        this.data = devices;
      }
    },
    async save() {
      var params = this.$copy(this.device);
      if (this.device_edit_index == -1) {
        const save = await this.$communicator("create_device", {
          params: params,
        });
        if (save.data.statusCode == 200) {
          this.$toast.success(`${save.data.message}`, { timeout: 2000 });
        }
      } else {
        const update = await this.$communicator("update_device", {
          arguments: [this.device_edit_index],
          params: params,
        });
        if (update.data.statusCode == 200) {
          this.$toast.success(`${update.data.message}`, { timeout: 2000 });
        }
      }
      this.update();
    },
  },
  computed: {
    shifted_stores() {
      const stores = this.$copy(this.stores);
      stores.shift();
      return stores;
    },
  },
  beforeMount() {
    this.store = this.$store.state.items_current_service;
    this.access = this.$store.state.access;
  },
};
</script>